export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 800;

export const CARD_WIDTH = 71;
export const CARD_HEIGHT = 96;
export const CARD_SCALE = 1.0;

export const SUITS = ['hearts', 'diamonds', 'clubs', 'spades'] as const;
export type Suit = typeof SUITS[number];

export const SUIT_COLORS: Record<Suit, string> = {
  hearts: '#e74c3c',
  diamonds: '#e74c3c',
  clubs: '#2c3e50',
  spades: '#2c3e50',
};

export const SUIT_SYMBOLS: Record<Suit, string> = {
  hearts: '\u2665',
  diamonds: '\u2666',
  clubs: '\u2663',
  spades: '\u2660',
};

export const RANK_NAMES: Record<number, string> = {
  1: 'A', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7',
  8: '8', 9: '9', 10: '10', 11: 'J', 12: 'Q', 13: 'K',
};

export const CARD_POINTS: Record<number, number> = {
  1: 15,  // Ace
  2: 20,  // 2 (as wild)
  3: 5, 4: 5, 5: 5, 6: 5, 7: 5,
  8: 10, 9: 10, 10: 10, 11: 10, 12: 10, 13: 10,
};
export const JOKER_POINTS = 30;

export const CLEAN_BURRACO_BONUS = 200;
export const DIRTY_BURRACO_BONUS = 100;
export const GOING_OUT_BONUS = 100;
export const NO_POZZETTO_PENALTY = -100;
export const WINNING_SCORE = 2005;

export const COLORS = {
  TABLE_GREEN: 0x2d6a4f,
  TABLE_FELT: 0x1b4332,
  CARD_BACK_RED: 0xc0392b,
  CARD_BACK_BLUE: 0x2980b9,
  HIGHLIGHT: 0xf1c40f,
  TEXT_LIGHT: '#ffffff',
  TEXT_DARK: '#1a1a2e',
  UI_BG: 0x16213e,
  UI_BORDER: 0x0f3460,
  BUTTON: 0x533483,
  BUTTON_HOVER: 0x7b2d8e,
};

export const PLAYER_ID = {
  HUMAN: 'human',
  AI: 'ai',
};
